import React, { useContext, useEffect, useState } from "react";
import { FirebaseContext } from "../../firebase";
import { Link } from "react-router-dom";

const CatalogoMadreDeDios = () => {
  const [insumos, setInsumos] = useState([]);
  const { firebase } = useContext(FirebaseContext);

  useEffect(() => {
    const unsubscribe = firebase.db
      .collection("productos_madre_de_dios")
      .onSnapshot((snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setInsumos(data);
      });

    return () => unsubscribe();
  }, [firebase.db]);

  // Función para cambiar el estado disponible/no disponible
  const cambiarEstado = async (insumoId, nuevoEstado) => {
    try {
      await firebase.db
        .collection("productos_madre_de_dios")
        .doc(insumoId)
        .update({ disponible: nuevoEstado });

      setInsumos(
        insumos.map((insumo) =>
          insumo.id === insumoId ? { ...insumo, disponible: nuevoEstado } : insumo
        )
      );
    } catch (error) {
      console.error("Error cambiando estado:", error);
    }
  };

  return (
    <div className="w-full h-full p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">📍 Catálogo Madre de Dios</h1>
        <Link
          to="/nuevo-insumo/madre_de_dios"
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          ➕ Añadir Insumo
        </Link>
      </div>

      <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="px-4 py-2">Imagen</th>
              <th className="px-4 py-2">Nombre</th>
              <th className="px-4 py-2">Categoría</th>
              <th className="px-4 py-2">Precio</th>
              <th className="px-4 py-2">UnidadMedida</th>
              <th className="px-4 py-2">Estado</th> {/* Nueva columna */}
              <th className="px-4 py-2 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {insumos.length > 0 ? (
              insumos.map((insumo) => (
                <tr key={insumo.id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-2">
                    {insumo.imagen ? (
                      <img
                        src={insumo.imagen}
                        alt={insumo.nombre}
                        className="w-16 h-16 object-cover rounded"
                      />
                    ) : (
                      <span className="text-gray-400 italic">Sin imagen</span>
                    )}
                  </td>
                  <td className="px-4 py-2">{insumo.nombre}</td>
                  <td className="px-4 py-2">{insumo.categoria}</td>
                  <td className="px-4 py-2 font-bold text-green-600">
                    S/. {insumo.precio}
                  </td>
                  <td className="px-4 py-2">{insumo.unidadMedida}</td>

                  {/* Columna Estado */}
                  <td className="px-4 py-2 text-center">
                    {insumo.disponible ? (
                      <button
                        className="bg-green-500 text-white px-3 py-1 rounded"
                        onClick={() => cambiarEstado(insumo.id, false)}
                      >
                        Disponible
                      </button>
                    ) : (
                      <button
                        className="bg-red-500 text-white px-3 py-1 rounded"
                        onClick={() => cambiarEstado(insumo.id, true)}
                      >
                        No disponible
                      </button>
                    )}
                  </td>

                  <td className="px-4 py-2 text-center">
                    <Link
                      to={`/editar-insumo/madre_de_dios/${insumo.id}`}
                      className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded mr-2"
                    >
                      ✏️ Editar
                    </Link>
                    <button
                      className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded"
                      onClick={() =>
                        firebase.db.collection("productos_madre_de_dios").doc(insumo.id).delete()
                      }
                    >
                      🗑 Eliminar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-500 italic">
                  No hay insumos registrados en Madre de Dios.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CatalogoMadreDeDios;
